import request from 'utils/request'

export function getRecruitList(filter, page, listRow) {
  let paramsd = Object.assign({page,listRow},filter)
  return request({
    url: '/hrRecruitController/getRecruitMessage',
    method: 'get',
    params: paramsd
  })
}

export function getHotList() {
  return request({
    url: '/hrRecruitController/getHotJob',
    method: 'get'
  })
}

export function getRecruitDetail(id) {
  return request({
    url: '/hrRecruitController/getByIdRecruitMessage',
    method: 'get',
    params: {
      id
    }
  })
}

export function getFilterOptions() {
  return request({
    url: '/hrOrgCompController/getAllCompany',
    method: 'get'
  })
}

export function getZplx() {
  return request({
    url: '/hdc/findAllType',
    method: 'get'
  })
}

export function getCompanyInfor() {
  return request({
    url: '/sysConfig/getCorpIntroduce',
    method: 'get'
  })
}

export function getJianjie() {
  return request({
    url: '/sysConfig/getCorpIntro'
  })
}
export function getApplyNotice() {
  return request({
    url: '/sysConfig/getApplyNotice'
  })
}



// WEBPACK FOOTER //
// ./src/api/recruit.js